"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonUserOnboarding = void 0;
const IdentityStep_1 = require("../../identity/domain/IdentityStep");
const PaymentInfoStep_1 = require("../../payment/domain/PaymentInfoStep");
const BaseUserOnboarding_1 = require("./BaseUserOnboarding");
const CommonOnboardingStepId_1 = require("./CommonOnboardingStepId");
const validator_1 = require("@leavy/validator");
const BaseUserOnboardingStep_1 = require("./BaseUserOnboardingStep");
const EmailVerificationStep_1 = require("../../email/domain/EmailVerificationStep");
const infrastructure_1 = require("../../infrastructure");
const CommonOnboardingStepTypes_1 = require("./CommonOnboardingStepTypes");
const CommonOnboardingExtraDataTypes_1 = require("./CommonOnboardingExtraDataTypes");
class CommonUserOnboarding extends BaseUserOnboarding_1.BaseUserOnboarding {
    constructor(id, data) {
        super(id);
        this.initialize(data);
    }
    get emailVerification() {
        return this.getStep(CommonOnboardingStepId_1.CommonOnboardingStepId.EMAIL_VERIFICATION, EmailVerificationStep_1.EmailVerificationStep);
    }
    get identity() {
        return this.getStep(CommonOnboardingStepId_1.CommonOnboardingStepId.IDENTITY, IdentityStep_1.IdentityStep);
    }
    get paymentInfo() {
        return this.getStep(CommonOnboardingStepId_1.CommonOnboardingStepId.PAYMENT_INFO, PaymentInfoStep_1.PaymentInfoStep);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "stepId",
            subTypes: Object
                .entries(CommonOnboardingStepTypes_1.CommonOnboardingStepTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], CommonUserOnboarding.prototype, "steps", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "dataTypeId",
            subTypes: Object
                .entries(CommonOnboardingExtraDataTypes_1.CommonOnboardingExtraDataTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], CommonUserOnboarding.prototype, "extraData", void 0);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", EmailVerificationStep_1.EmailVerificationStep),
    __metadata("design:paramtypes", [])
], CommonUserOnboarding.prototype, "emailVerification", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", IdentityStep_1.IdentityStep),
    __metadata("design:paramtypes", [])
], CommonUserOnboarding.prototype, "identity", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", PaymentInfoStep_1.PaymentInfoStep),
    __metadata("design:paramtypes", [])
], CommonUserOnboarding.prototype, "paymentInfo", null);
exports.CommonUserOnboarding = CommonUserOnboarding;
//# sourceMappingURL=CommonUserOnboarding.js.map